
export class Orientation {
  public heading = null;
  public pitch = null;
  public roll = null;

  constructor(heading, pitch, roll) {
    this.heading = heading;
    this.pitch = pitch;
    this.roll = roll;
  }
}


